import { useMutation, useQueryClient } from 'react-query';
import { useToast } from '../../context/ToastProvider';
import { Modal, Button } from 'flowbite-react';
import React from 'react';
import { RxCross2 } from 'react-icons/rx';
import { linkLMSAccount } from '../../apis/user';
import { useUserContext } from 'src/context/UserProvider';
import { useSearchParams } from 'react-router-dom';

const ShowCanLinkLMSProfileModal = () => {
	const toast = useToast();
	const [searchParams, setSearchParams] = useSearchParams();
	const queryClient = useQueryClient();
	const { showLinkLMSProfileModal, setShowLinkLMSProfileModal, studentCode } = useUserContext();
	const jwtInternalStudentLinkToken = searchParams.get('lms-token');

	const linkAccoutnMutationFn = useMutation(['linkLMSAccount'], linkLMSAccount, {
		onSuccess() {
			toast({
				title: 'Account linked successfully!',
				type: 'success',
			});
			queryClient.refetchQueries('verifyCookie');
			setIsLoading(false);
			onClose();
		},
		onError(error: Error) {
			setIsLoading(false);
			toast({
				title: `Error occured while deleting user  ${error.message}`,
				type: 'error',
			});
		},
	});

	const onClose = () => {
		searchParams.delete('lms-token');
		setSearchParams(searchParams);
		setShowLinkLMSProfileModal(false);
	};

	const [isLoading, setIsLoading] = React.useState(false);
	return (
		<div>
			<Modal position={'center'} dismissible={true} size={'md'} show={showLinkLMSProfileModal} onClose={onClose}>
				<Modal.Body className="relative flex flex-col gap-y-8 justify-center rounded-[8px] border border-solid border-[#555770] dark:bg-[#1F2A37] p-8">
					<div>
						<h6 className="font-inter text-[20px] font-[600] leading-[120%]">Link your LMS account</h6>
						<p className="mt-[16px] font-inter text-[16px] font-[400] leading-[24px]">
							Are you sure you want to link your LMS <span className="text-[#7777E7]">{studentCode}</span> profile to
							this LevelUp account?
						</p>
						{/* <p className="mt-[16px] font-inter text-[16px] font-[400] leading-[24px]">
							To confirm deletion, type “DELETE” below:
						</p>
						<input
							className="mt-[16px] w-[100%] rounded-[8px] dark:bg-[#374151] border border-[#EBEBF0] dark:border-[#4B5563] "
							type="text"
							placeholder={'type DELETE here...'}
							value={deleteInputValue}
							onChange={e => setDeleteInputValue(e.target.value)}
						/> */}
						<div className="mt-[16px] flex items-center gap-[16px] justify-center">
							<Button
								disabled={isLoading}
								color="purplePlaced"
								onClick={() => {
									setIsLoading(true);
									if (studentCode)
										linkAccoutnMutationFn.mutate({
											studentCode,
											jwtInternalStudentLinkToken: jwtInternalStudentLinkToken ?? '',
										});
								}}
							>
								Confirm
							</Button>
							<Button color="light" onClick={onClose}>
								No, Cancel
							</Button>
						</div>
					</div>
					<RxCross2
						onClick={onClose}
						className="absolute right-[10px] top-[10px] h-[20px] w-[20px] cursor-pointer text-[#9CA3AF]"
					/>
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default ShowCanLinkLMSProfileModal;
